import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'

export default function WelcomeSection() {
    const userDetails = useSelector(state => state.user?.userDetails)
    return (
        <div className="az-content-header d-block d-md-flex">
            <div>
                <h2 className="az-content-title mg-b-5 mg-b-lg-8">Welcome {userDetails?.name || 'John Doe'}!</h2>
            </div>
            
            <div className="az-dashboard-header-right">
                <div>
                    <label className="tx-13">{moment(new Date()).format("hh:mm A")} | {moment(new Date()).format("DD MMMM yyyy")}  | <span className='text-capitalize'>{userDetails?.role==="superAdmin" ? "Super Admin" : userDetails?.role}</span> Account</label>
                </div>
            </div>
        </div>
    )
}
